export interface ISourceItemData {
    guid: string;
    description: string | null;
}

export interface ISourceItemDataExtended extends ISourceItemData {
    order: number;
    jsonData: Record<string, string | number | boolean | string[] | null>;
    code: string | null;
    externalCode: string | null;
    isActive: boolean;
    children?: ISourceItemDataExtended[];
}

export type EstensaRestControllerType =
    | 'ListEcg'
    | 'List'
    | 'ListCpReporting'
    | 'ListWorkFlow'
    | 'Visit'
    | 'Worklist'
    | 'Workflow'
    | 'RadiologyCommon'
    | 'CustomPageInternal'
    | 'Report'
    | 'Senology'
    | 'Execution'
    | 'ECG'
    | 'ClinicalRepository';

export enum EstensaRestListType {
    lsBusinessUnit = 'lsBusinessUnit',
    lsNurse = 'lsNurse',
    lsSonographer = 'lsSonographer',
    lsUsMeasureExtension = 'lsUsMeasureExtension',
    lsUsEquipment = 'lsUsEquipment',
    lsModality = 'lsModality',
    lsEquipment = 'lsEquipment',
    lsPostgraduate = 'lsPostgraduate',
    lsExam = 'lsExam',
    lsReferringPhysician = 'lsReferringPhysician',
    lsProvenance = 'lsProvenance',
    lsProvenanceGroup = 'lsProvenanceGroup',
    lsRoom = 'lsRoom',
    lsSeverity = 'lsSeverity',
    lsRole = 'lsRole',
    lsVisitType = 'lsVisitType',
    lsAdministrator = 'lsAdministrator',
    lsTechnician = 'lsTechnician', //tecnico per l'esecuzione
    lsAnaesthetist = 'lsAnaesthetist',
    LsUser = 'LsUser',
    lsExecutor = 'lsExecutor', //tecnico/medico per l'accettazione
    LsAgenda = 'LsAgenda',
    lsSuspensionReason = 'lsSuspensionReason',
    lsDeletingReason = 'lsDeletingReason',
    lsAnatomicalPart = 'lsAnatomicalPart',
    tbExamGroup = 'tbExamGroup',
    LsRadiologyDepartment = 'LsRadiologyDepartment',
    lsCharge = 'lsCharge',
    lsPriceList = 'lsPriceList',
    lsAuthorizationType = 'lsAuthorizationType',
    lsRequestingPhysician = 'lsRequestingPhysician',
    lsDeliveryLocation = 'lsDeliveryLocation',
    lsPatientStatus = 'lsPatientStatus',
    lsPredefinedTextGroup = 'lsPredefinedTextGroup',
    lsRadioPredefinedReport = 'lsRadioPredefinedReport',
    lsSex = 'lsSex',
    lsRace = 'lsRace',
    lsCity = 'lsCity',
    lsResidenceCity = 'lsResidenceCity',
    lsCivilStatus = 'lsCivilStatus',
    lsAddress = 'lsAddress',
    lsProfession = 'lsProfession',
    lsSource = 'lsSource',
    lsUsExam = 'lsUsExam',
    lsHistoricalCity = 'lsHistoricalCity',
    lsDeliveryDocumentationType = 'lsDeliveryDocumentationType',
    lsDoseClass = 'lsDoseClass',
    lsMinisterialCode = 'lsMinisterialCode',
    lsRadioactiveTracer = 'lsRadioactiveTracer',
    lsModule = 'lsModule',
    lsReportHistorySource = 'lsReportHistorySource'
}

export interface IMandatoryEquipmentChangeDTO {
    idExaminations: string[];
    idEquipment: string;
}

export type MandatoryEquipmentChangeError = IMandatoryEquipmentChangeDTO;
